import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { Stat } from '../../../dashboard.interfaces';

@Component({
  selector: 'etoh-stat-display',
  templateUrl: './stat-display.component.html',
  styleUrls: ['./stat-display.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [FlexLayoutModule, CommonModule, NzToolTipModule, NzIconModule],
})
export class StatDisplayComponent {
  stat = input.required<Stat>();

  clickAction = computed(() => {
    return this.stat().click ? (this.stat().click as any) : () => {};
  });
}
